import React from "react";
import { BatteryCharging, Cpu, Shield, ShieldCheck, SunMedium } from "lucide-react";
import { Container } from "./Container";
import { Reveal } from "./Reveal";
import { WARRANTIES } from "../../lib/content";
import { IconBadge } from "./IconBadge";

const ICONS = { Shield, ShieldCheck, SunMedium, Cpu, BatteryCharging };

export const WarrantyBand = ({ testId = "section-warranty" }) => (
  <section
    data-testid={testId}
    className="bg-brand-orange-tint border-y border-border"
  >
    <Container className="py-20 md:py-24">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
        {WARRANTIES.map((w, i) => {
          const Icon = ICONS[w.icon] || Shield;
          return (
            <Reveal key={w.label} delay={i * 0.05}>
              <div
                className="flex md:flex-col items-start gap-5"
                data-testid={`warranty-${i}`}
              >
                <IconBadge icon={Icon} size="lg" tone="plain" />
                <div>
                  <div className="qv-stat">
                    {w.years}
                    <span className="text-brand-orange">.</span>
                    <span className="text-[1rem] ml-1 text-subtle align-middle font-sans tracking-normal">
                      year
                    </span>
                  </div>
                  <div className="qv-h3 mt-3">{w.label}</div>
                  <p className="qv-body mt-1.5">{w.verbatim}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Container>
  </section>
);

export default WarrantyBand;
